import React from 'react';
import c from 'classnames';
import s from './FacetContent.scss';
const FacetContent = ({ size, children, className })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s[`size-${size}`], className)
    }, children);
};
FacetContent.displayName = 'FacetContent';
export default FacetContent;
